import type { TweenVars } from "./types.js";

export type TimelineOperation = {
  code: string;
};

function serialize(value: unknown): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}

export class TimelineBuilder {
  constructor(
    private readonly pushOperation: (operation: TimelineOperation) => void,
    private readonly offset = 0,
  ) {}

  to(selector: string, vars: TweenVars, at: number): void {
    this.pushOperation({
      code: `tl.to(${serialize(selector)}, ${serialize(vars)}, ${serialize(this.offset + at)});`,
    });
  }

  fromTo(selector: string, from: TweenVars, to: TweenVars, at: number): void {
    this.pushOperation({
      code: `tl.fromTo(${serialize(selector)}, ${serialize(from)}, ${serialize(to)}, ${serialize(this.offset + at)});`,
    });
  }

  set(selector: string, vars: TweenVars, at: number): void {
    this.pushOperation({
      code: `tl.set(${serialize(selector)}, ${serialize(vars)}, ${serialize(this.offset + at)});`,
    });
  }
}
